<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rVBkzh/tc-custom/9781526778116.jpg?1712387829700" alt="This image is the cover for the book Korean War—Chinese Invasion, Cold War, 1945–1991"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Korean War—Chinese Invasion, Cold War, 1945–1991
      </h1>
      <p class="bookDescription body article font2">
        <p>In his first four volumes on the Korean War, the author traces the war’s progress from the North Korean invasion of June 1950, the desperate American defense of the Pusan Perimeter, General Douglas MacArthur’s daring and highly successful amphibious offensive at Inch’on, and his subsequent advance across the 38th Parallel to the Yalu River on the Chinese Manchurian border  Communist Chinese forces, that have been secretly infiltrating North Korean territory by slipping across the Yalu from mid-October 1950, ambush a South Korean regiment in the mountains of central North Korea. This is the first of several Chinese victories over unsuspecting and overstretched South Korean and American units in the winter of 1950/1.  On 27 November 1950, Chinese leader Mao Zedong, ostensibly fearful of the consequences of hostile American forces on his country’s border along the Yalu River, orders 250,000 troops into Korea, with express orders to annihilate the UN forces. In the western half of the theater, US General Walton H. Walker’s Eighth Army front along the Ch’ongch’on axis is breached, while to the east, the US X Corps suffers a series of crushing defeats, including at the Chosin Reservoir, precipitating a massive evacuation from the North Korean port of Hungnam.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gerry van Tonder
      </h2>
      
      <p class="authorDescription body article">Born in Southern Rhodesia, now Zimbabwe, historian and author Gerry van Tonder came to Britain in 1999. Specializing in military history, Gerry has authored multiple books on Rhodesia and the co-authored definitive Rhodesia Regiment 1899–1981. Gerry presented a copy to the regiment’s former colonel-in-chief, Her Majesty the Queen.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?422692c2